import React from "react";
import { useHistory } from "react-router-dom";

const Report = () => {
  const history = useHistory();
  React.useEffect(() => history.push("/"), [history]);
  return <div />;
};

export default Report;
